import { useSelector } from 'react-redux';

import { selectActiveItem } from '../slices/storyboardSlice';

export default function useActiveItem() {
  return useSelector(selectActiveItem) || {};
}
